import React, { useEffect, useMemo, useState } from "react"
import { enumUtil } from "../../../../utils/Enum"
import FormValidator from "../../../../utils/FormValidator"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../utils/NotificationHandler"
import isNull from "../../../../utils/NullChecking"
import Loader from "../../../shared/Loader/Loader"
import Modal from 'react-bootstrap/Modal';
import DeleteConfirmatiom from "../../../General/DeleteConfirmation"
import Audit from "../../../General/Audit"
import ModalHeader from "../../Shared/ModalHeader"
import ModalFooter from "../../Shared/ModalFooter"
import { useSelector } from "react-redux"
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList"
import { NDCUnitOfMeasurement, TOSCodes } from "../../../../utils/Constants"
import handleNumericCheck from "../../../../utils/HandleNumericKeys"
import DropdownValueHandler from "../../../shared/SuperSearch/DropdownValueHandler"
import DropdownCodeHandler from "../../../shared/SuperSearch/DropdownCodeHandler"
import handleDecimalCheck from "../../../../utils/handleDecimalCheck"
import OpenQuickPopup from "../../../shared/OpenQuickPopup/OpenQuickPopup"
import { FindSecondChild } from "../../../../utils/FindMenuOption"
const AddNewProcedureCodes = (props) => {
    let IsEditAllowed = FindSecondChild('Setup', 'Codes', 'Procedures')?.IsAdd
    let IsDeleteAllowed = FindSecondChild('Setup', 'Codes', 'Procedures')?.IsDeleted
    let valModal = {}
    let ValidationModal = {
        ProcedureCodeVal: "",
    }

    let Procedure_Modal = {
        ProcedureCode: null,
        ShortName: "",
        Description: "",
        FullDescription: "",
        Amount: "",
        AllowedAmount: "",
        Category: '', //DD
        DefaultUnits: '',
        POSCode: '', //DD
        TosCode: '', //DD
        GlobalPeriodDays: '',
        DefaultModifierCode1: '',
        DefaultModifierCode2: '',
        DefaultModifierCode3: '',
        DefaultModifierCode4: '',
        Ub04RevenueCode: '',
        RequireCLIA: false,
        UseDefaultAmount: false,
        RequireDescription: "",
        NDCCode: '',
        NDCDescription: '',
        NDCUnitPrice: '',
        NDCQuantity: '',
        NDCUnitOfMeasurement: '',
        UpdatedDate: "",
        UpdatedBy: ""

    }
    const [ProcedureCodes, setProcedureCodes] = useState()
    const [ProcedureValidationModal, setProcedureValidationModal] = useState(ValidationModal)
    const [ProcedureSaveUpdateModal, setProcedureSaveUpdateModal] = useState({})
    const [mainProcedureModal, setmainProcedureModal] = useState(Procedure_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [del, setDel] = useState(false)
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const API_URL = enumUtil.controller.General
    const [isOpenAudit, setisOpenAudit] = useState(false);
    const { isOpenProcedure, onClose, onDeleteProcedure, type, handleOnSaveICD, isOpenFromList } = { ...props }
    const [onProcedureSave, setOnProcedureSave] = useState(false)
    const [modifierBody, setmodifierBody] = useState({ "TableName": enumUtil.enumAPITableName.Modifier, "SearchParam": '' })
    const [UB04Body, setUB04Body] = useState({ "TableName": enumUtil.enumAPITableName.RevenueCode, "SearchParam": '' })
    const [is, setIs] = useState(false);
    const [popup, setPopup] = useState(<></>);
    const API_URL_Claim = enumUtil.controller.Claim
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer)
    useEffect(() => {
        if (props.ProcedureCode != null && !isOpenFromList) {
            setProcedureCodes(props.ProcedureCode)
            setDel(true);
        } else {
            if (!onProcedureSave) {
                setProcedureCodes(0);
                setDel(false);
            } else {
                setDel(true);
            }

        }
    }, [])
    useEffect(() => {
        if (!isNull(ProcedureCodes) && !isOpenFromList) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": ProcedureCodes,
                "TableName": enumUtil.enumAPITableName.Procedure
            }).then((response) => {
                setIsLoading(false)
                setIs(true)
                response.POSCode = DropdownCodeHandler(DropDowns?.POS, response.POSCode)
                response.TosCode = DropdownValueHandler(TOSCodes, response.TosCode)
                response.NDCUnitOfMeasurement = DropdownValueHandler(NDCUnitOfMeasurement, response.NDCUnitOfMeasurement)
                setmainProcedureModal(response)
                // setPracticeID(response.PracticeID)
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
    }, [ProcedureCodes])
    useEffect(() => {
        if (isOpenFromList) {
            setmainProcedureModal({ ...mainProcedureModal, ProcedureCode: props.ProcedureCode })
            setProcedureSaveUpdateModal({ ...ProcedureSaveUpdateModal, ProcedureCode: props.ProcedureCode })
        }
    }, [isOpenFromList])
    const handleProcedureChange = (e) => {
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainProcedureModal };
        let saveModal = { ...ProcedureSaveUpdateModal }
        if (name === "RequireCLIA" || name === 'RequireDescription' || name === 'UseDefaultAmount') {
            modal[name] = !modal[name]
        } else {
            modal[name] = value
        }
        setmainProcedureModal(modal)
        for (var property in Procedure_Modal) {
            if (name === property) {
                if (name === "RequireCLIA" || name === 'RequireDescription' || name === 'UseDefaultAmount') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }
            }
        }
        setProcedureSaveUpdateModal(saveModal)
    }
    const ProcedureValidation = async () => {
        let ValidationModal = {
            ProcedureCodeVal: FormValidator(
                mainProcedureModal.ProcedureCode,
                enumUtil.enumValidationType.Required,
                'Procedure Code',
            )
        }
        await setProcedureValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleSaveProcedure = async () => {
        await ProcedureValidation()
        // setProcedureCodes(mainProcedureModal.ProcedureCode)
        // setProcedureCodes(ProcedureCodes)
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setProcedureSaveUpdateModal(ProcedureSaveUpdateModal)
            let saveModal = {
                TableName: enumUtil.enumAPITableName.Procedure,
                ID: ProcedureCodes === null ? '0' : ProcedureCodes,
                data: { ...ProcedureSaveUpdateModal },
                value: null
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    // console.log("response", response)
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        onDeleteProcedure()
                        NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                        setProcedureCodes(response.id)
                        setOnProcedureSave(true)
                        handleOnSaveICD({ display: mainProcedureModal.ProcedureCode, value: response.id })
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    console.log('error', error);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }
    const SetProcedureName = () => {
        if (mainProcedureModal.ProcedureCode != null && mainProcedureModal.ProcedureCode != "") {
            return (
                <p className="heading sm">{mainProcedureModal.ProcedureCode}</p>
            )
        } else {
            return (
                <p className="heading sm">Add New Procedure Code</p>
            )
        }
    }
    const handleDeleteModal = () => {
        setisOpenAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenAlert(false)
    }
    let DeletePopup = ""
    if (del) {
        DeletePopup = <button className={IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent '} onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.Procedure} ID={ProcedureCodes} onClose={onDeleteProcedure} />
    }
    const handleAuditModal = () => {
        setisOpenAudit(true)
    }
    const onCloseAudit = () => {
        setisOpenAudit(false)
    }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={ProcedureCodes + ""} TableName={enumUtil.enumAPITableName.Procedure} />
    }
    const handleChangeDD = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainProcedureModal };
        modal[name] = value
        if (name === 'DefaultModifierCode1' || name === 'DefaultModifierCode2' || name === 'DefaultModifierCode3' || name === 'DefaultModifierCode4') {
            setmodifierBody({ "TableName": enumUtil.enumAPITableName.Modifier, "SearchParam": value })
        } else if (name === 'Ub04RevenueCode') {
            setUB04Body({ "TableName": enumUtil.enumAPITableName.RevenueCode, "SearchParam": value })
        }
        setmainProcedureModal(modal)
    }
    const handleSelectedData = (selectedData, name, type) => {
        let modal = { ...mainProcedureModal };
        if (type === 'client' && !isNull(selectedData)) {
            if (name === 'POSCode') {
                modal[name] = selectedData.display
                ProcedureSaveUpdateModal['POSCode'] = selectedData.code
                ProcedureSaveUpdateModal['POSCodeID'] = selectedData.value + ""
            } else if (name === 'TosCode') {
                modal[name] = selectedData.display
                ProcedureSaveUpdateModal[name] = selectedData.value
            } else if (name === 'NDCCode') {
                modal[name] = selectedData.display
                ProcedureSaveUpdateModal[name] = selectedData.value
            } else if (name === 'NDCUnitOfMeasurement') {
                modal[name] = selectedData.display
                ProcedureSaveUpdateModal[name] = selectedData.value
            }

        } else if (type === 'server' && !isNull(selectedData)) {
            if (name === 'DefaultModifierCode1') {
                modal[name] = selectedData.display
                ProcedureSaveUpdateModal[name] = selectedData.display + ""
                ProcedureSaveUpdateModal['DefaultModifierCodeID1'] = selectedData.value + ""
            } else if (name === 'DefaultModifierCode2') {
                modal[name] = selectedData.display
                ProcedureSaveUpdateModal[name] = selectedData.display + ""
                ProcedureSaveUpdateModal['DefaultModifierCodeID2'] = selectedData.value + ""
            } else if (name === 'DefaultModifierCode3') {
                modal[name] = selectedData.display
                ProcedureSaveUpdateModal[name] = selectedData.display + ""
                ProcedureSaveUpdateModal['DefaultModifierCodeID3'] = selectedData.value + ""
            } else if (name === 'DefaultModifierCode4') {
                modal[name] = selectedData.display
                ProcedureSaveUpdateModal[name] = selectedData.display + ""
                ProcedureSaveUpdateModal['DefaultModifierCodeID4'] = selectedData.value + ""
            } else if (name === 'Ub04RevenueCode') {
                modal[name] = selectedData.display
                ProcedureSaveUpdateModal[name] = selectedData.code + ""
                ProcedureSaveUpdateModal['Ub04RevenueCodeID'] = selectedData.value + ""
            }
        } else {
            modal[name] = ''
            ProcedureSaveUpdateModal[name] = ''
        }
        setmainProcedureModal(modal)

        return selectedData
    }
    const AddNewProcedureCodesModalBody = () => {
        return (
            <div className="row m-0 procedure_code">
                <div className="col-md-4">
                    <div className="row rows-half mb-2">
                        <div className="col-md-6">
                            <div className='form-group input'>
                                <div className={ProcedureValidationModal.ProcedureCodeVal ? 'form-group input error' : 'form-group input'}>
                                    <label htmlFor="ProcedureCode">Procedure Code<span className='req'>*</span></label>
                                    <input type="text"
                                        className='form-control'
                                        name="ProcedureCode"
                                        id="ProcedureCode"
                                        autoComplete="off"
                                        maxLength={5}
                                        value={mainProcedureModal.ProcedureCode}
                                        onChange={handleProcedureChange}
                                    />
                                    {ProcedureValidationModal.ProcedureCodeVal}
                                </div>

                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className='form-group input'>
                                <label htmlFor="DefaultUnits">Short Name</label>
                                <input type="text"
                                    className='form-control'
                                    name="ShortName"
                                    id="ShortName"
                                    autoComplete="off"
                                    value={mainProcedureModal.ShortName}
                                    // onKeyPress={handleNumericCheck}
                                    onChange={handleProcedureChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='form-group input'>
                        <label htmlFor="Description">Description</label>
                        <textarea type="text"
                            rows={5}
                            className='form-control description'
                            name="Description"
                            id="Description"
                            autoComplete="off"
                            value={mainProcedureModal.Description}
                            onChange={handleProcedureChange}
                        />
                    </div>
                    <div className="row rows-half mb-2">
                        <div className="col-md-6">
                            <div className='form-group input'>
                                <label htmlFor="Amount">Amount</label>
                                <input
                                    type="text"
                                    className='form-control'
                                    name="Amount"
                                    id="Amount"
                                    autoComplete="off"
                                    value={mainProcedureModal.Amount}
                                    onKeyPress={handleDecimalCheck}
                                    onChange={handleProcedureChange}
                                />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className='form-group input'>
                                <label htmlFor="AllowedAmount">Allowed Amount</label>
                                <input type="text"
                                    className='form-control'
                                    name="AllowedAmount"
                                    id="AllowedAmount"
                                    autoComplete="off"
                                    value={mainProcedureModal.AllowedAmount}
                                    onKeyPress={handleDecimalCheck}
                                    onChange={handleProcedureChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="form-check custom_check_box form-check-inline me-0">
                        <label htmlFor="UseDefaultAmount" className="text fs-9" >Use Default Amount if fee schedule is not created</label>
                        <input type="checkbox"
                            className="form-check-input p-0 mt-1"
                            name="UseDefaultAmount"
                            id="UseDefaultAmount"
                            autoComplete="off"
                            checked={mainProcedureModal.UseDefaultAmount}
                            onChange={handleProcedureChange}
                        />
                    </div>
                    <div className="row rows-half mb-2">
                        <div className="col-md-6">
                            <div className='form-group input'>
                                <label htmlFor="DefaultUnits">Default Units</label>
                                <input type="text"
                                    className='form-control'
                                    name="DefaultUnits"
                                    id="DefaultUnits"
                                    autoComplete="off"
                                    value={mainProcedureModal.DefaultUnits}
                                    onKeyPress={handleNumericCheck}
                                    onChange={handleProcedureChange}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className='form-group input'>
                                <label htmlFor="Category">Category</label>
                                <input type="text"
                                    className='form-control'
                                    name="Category"
                                    id="Category"
                                    autoComplete="off"
                                    value={mainProcedureModal.Category}
                                    onChange={handleProcedureChange}
                                />
                            </div>
                        </div>
                    </div>
                    {/* <div className='form-group input'>
                        <label htmlFor="Category">Category</label>
                        <input type="text"
                            className='form-control'
                            name="Category"
                            id="Category"
                            autoComplete="off"
                            value={mainProcedureModal.Category}
                            onChange={handleProcedureChange}
                        />
                    </div> */}
                    <div className='form-group input'>
                        <div className="label-head d-flex justify-content-between mb-1">
                            <label htmlFor="">POS Code</label>
                            {useMemo(() => { return <OpenQuickPopup ID={null} setPopup={setPopup} popupName={'POS'} type={"AddIcon"} /> }, [])}
                        </div>
                        <SuperSearchList
                            type="client"
                            id='POSCode'
                            name='POSCode'
                            searchValue={mainProcedureModal.POSCode}
                            data={DropDowns.POS}
                            onChange={handleChangeDD}
                            getSelectedData={handleSelectedData}
                            is={is}
                            sup_btn='sup_btn-Inp'
                            sup_inp='superSearchVisitInp'
                        />
                    </div>
                    <div className='form-group input'>
                        <label htmlFor="TosCode">Tos Code</label>
                        {/* <input type="text"
                        className='form-control'
                        name="TosCode"
                        id="TosCode"
                        value={mainProcedureModal.DefaulTosCodetUnits}
                        onChange={handleProcedureChange}
                    /> */}
                        <SuperSearchList
                            type="client"
                            id='TosCode'
                            name='TosCode'
                            searchValue={mainProcedureModal.TosCode}
                            data={TOSCodes}
                            onChange={handleChangeDD}
                            getSelectedData={handleSelectedData}
                            is={is}
                            sup_btn='sup_btn-Inp'
                            sup_inp='superSearchVisitInp'
                        />
                    </div>
                </div>
                <div className="col-md-4 ">
                    <div className="row rows-half mb-2">
                        <div className="col-md-6">
                            <div className='form-group input'>
                                <label htmlFor="GlobalPeriodDays">Global Period Days</label>
                                <input type="text"
                                    className='form-control'
                                    name="GlobalPeriodDays"
                                    id="GlobalPeriodDays"
                                    autoComplete="off"
                                    value={mainProcedureModal.GlobalPeriodDays}
                                    onChange={handleProcedureChange}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className='form-group input'>
                                <label htmlFor="Ub04RevenueCode">UB04 Revenue Code</label>
                                {/* <input type="text"
                                className='form-control'
                                name="Ub04RevenueCode"
                                id="Ub04RevenueCode"
                                value={mainProcedureModal.Ub04RevenueCode}
                                onChange={handleProcedureChange}
                            /> */}
                                <SuperSearchList
                                    type='server'
                                    id='Ub04RevenueCode'
                                    name='Ub04RevenueCode'
                                    searchValue={mainProcedureModal.Ub04RevenueCode}
                                    ApiLink={API_URL + "/InstantSearch"}
                                    method='post'
                                    postBody={UB04Body}
                                    // onChange={(e) => handleChangeInstantSearch(e, 'Modifier', data.RowID)}
                                    onChange={handleChangeDD}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                    placeholder={false}
                                    icon={true}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='form-group input'>
                        <div className="label-head d-flex justify-content-between mb-1">
                            <label htmlFor="">Default Modifier Code 1</label>
                            {useMemo(() => { return <OpenQuickPopup ID={null} setPopup={setPopup} popupName={'Modifiers'} type={"AddIcon"} /> }, [])}
                        </div>
                        <SuperSearchList
                            type='server'
                            id='DefaultModifierCode1'
                            name='DefaultModifierCode1'
                            searchValue={mainProcedureModal.DefaultModifierCode1}
                            ApiLink={API_URL_Claim + "/ModifierInstantSearch"}
                            method='post'
                            postBody={modifierBody}
                            onChange={handleChangeDD}
                            getSelectedData={handleSelectedData}
                            is={is}
                            sup_btn='sup_btn-Inp'
                            sup_inp='superSearchVisitInp'
                            placeholder={false}
                            icon={true}
                        />
                    </div>
                    <div className='form-group input'>
                        <label htmlFor="DefaultModifierCode2">Default Modifier Code 2</label>
                        {/* <input type="text"
                        className='form-control'
                        name="DefaultModifierCode2"
                        id="DefaultModifierCode2"
                        value={mainProcedureModal.DefaultModifierCode2}
                        onChange={handleProcedureChange}
                    /> */}
                        <SuperSearchList
                            type='server'
                            id='DefaultModifierCode2'
                            name='DefaultModifierCode2'
                            searchValue={mainProcedureModal.DefaultModifierCode2}
                            ApiLink={API_URL_Claim + "/ModifierInstantSearch"}
                            method='post'
                            postBody={modifierBody}
                            onChange={handleChangeDD}
                            getSelectedData={handleSelectedData}
                            is={is}
                            sup_btn='sup_btn-Inp'
                            sup_inp='superSearchVisitInp'
                            placeholder={false}
                            icon={true} />
                    </div>
                    <div className='form-group input'>
                        <label htmlFor="DefaultModifierCode3">Default Modifier Code 3</label>
                        <SuperSearchList
                            type='server'
                            id='DefaultModifierCode3'
                            name='DefaultModifierCode3'
                            searchValue={mainProcedureModal.DefaultModifierCode3}
                            ApiLink={API_URL_Claim + "/ModifierInstantSearch"}
                            method='post'
                            postBody={modifierBody}
                            onChange={handleChangeDD}
                            getSelectedData={handleSelectedData}
                            is={is}
                            sup_btn='sup_btn-Inp'
                            sup_inp='superSearchVisitInp'
                            placeholder={false}
                            icon={true}
                        />
                    </div>
                    <div className='form-group input'>
                        <label htmlFor="DefaultModifierCode4">Default Modifier Code 4</label>
                        {/* <input type="text" 
                            className='form-control' 
                            name="DefaultModifierCode4"
                            id="DefaultModifierCode4"
                            value={mainProcedureModal.DefaultModifierCode4}
                            onChange={handleProcedureChange} 
                            /> */}
                        <SuperSearchList
                            type='server'
                            id='DefaultModifierCode4'
                            name='DefaultModifierCode4'
                            searchValue={mainProcedureModal.DefaultModifierCode4}
                            ApiLink={API_URL_Claim + "/ModifierInstantSearch"}
                            method='post'
                            postBody={modifierBody}
                            // onChange={(e) => handleChangeInstantSearch(e, 'Modifier', data.RowID)}
                            onChange={handleChangeDD}
                            getSelectedData={handleSelectedData}
                            is={is}
                            sup_btn='sup_btn-Inp'
                            sup_inp='superSearchVisitInp'
                            placeholder={false}
                            icon={true}
                        />
                    </div>
                    <div className="form-check custom_check_box form-check-inline">
                        <label htmlFor="RequireCLIA" className="text">Require CLIA</label>
                        <input type="checkbox"
                            className="form-check-input p-0 mt-1"
                            name="RequireCLIA"
                            id="RequireCLIA"
                            autoComplete="off"
                            checked={mainProcedureModal.RequireCLIA}
                            onChange={handleProcedureChange}
                        />
                    </div>
                    <div className="form-check custom_check_box form-check-inline me-0">
                        <label htmlFor="RequireDescription" className="text" >Require Description</label>
                        <input type="checkbox"
                            className="form-check-input p-0 mt-1"
                            name="RequireDescription"
                            id="RequireDescription"
                            autoComplete="off"
                            checked={mainProcedureModal.RequireDescription}
                            onChange={handleProcedureChange}
                        />
                    </div>

                </div>
                <div className="col-md-4">
                    <div className='form-group input'>
                        <label htmlFor="NDCCode">NDC Code</label>
                        <input type="text"
                            className='form-control'
                            name="NDCCode"
                            id="NDCCode"
                            autoComplete="off"
                            maxLength={11}
                            onKeyPress={handleNumericCheck}
                            value={mainProcedureModal.NDCCode}
                            onChange={handleProcedureChange}
                        />
                    </div>
                    <div className='form-group input'>
                        <label htmlFor="NDCDescription">NDC Description</label>
                        <textarea type="text"
                            rows={6}
                            className='form-control description'
                            name="NDCDescription"
                            id="NDCDescription"
                            value={mainProcedureModal.NDCDescription}
                            onChange={handleProcedureChange}
                        />
                    </div>
                    <div className="row rows-half mb-2">
                        <div className="col-md-6">
                            <div className='form-group input'>
                                <label htmlFor="NDCUnitPrice">NDC Unit Price</label>
                                <input type="text"
                                    className='form-control'
                                    name="NDCUnitPrice"
                                    id="NDCUnitPrice"
                                    autoComplete="off"
                                    value={mainProcedureModal.NDCUnitPrice}
                                    onKeyPress={handleDecimalCheck}
                                    onChange={handleProcedureChange}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className='form-group input'>
                                <label htmlFor="NDCQuantity">NDC Quantity</label>
                                <input type="text"
                                    className='form-control'
                                    name="NDCQuantity"
                                    id="NDCQuantity"
                                    autoComplete="off"
                                    value={mainProcedureModal.NDCQuantity}
                                    onKeyPress={handleDecimalCheck}
                                    onChange={handleProcedureChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='form-group input'>
                        <label htmlFor="NDCUnitOfMeasurement">NDC Unit Of Measurement</label>
                        {/* <input type="text"
                        className='form-control'
                        name="NDCUnitOfMeasurement"
                        id="NDCUnitOfMeasurement"
                        value={mainProcedureModal.NDCUnitOfMeasurement}
                        onChange={handleProcedureChange}
                    /> */}
                        <SuperSearchList
                            type="client"
                            id='NDCUnitOfMeasurement'
                            name='NDCUnitOfMeasurement'
                            searchValue={mainProcedureModal.NDCUnitOfMeasurement}
                            data={NDCUnitOfMeasurement}
                            onChange={handleChangeDD}
                            getSelectedData={handleSelectedData}
                            is={is}
                            sup_btn='sup_btn-Inp'
                            sup_inp='superSearchVisitInp'
                        />
                    </div>
                    {/* <div className='form-group input'>
                            <label htmlFor="FullDescription">Full Description</label>
                            <textarea type="text" 
                            rows={5}
                            className='form-control' 
                            name="FullDescription"
                            id="FullDescription"
                            value={mainProcedureModal.FullDescription}
                            onChange={handleProcedureChange} 
                            />
                        </div> */}
                </div>
            </div>
        )
    }
    return (
        <React.Fragment>
            {DeleteConfirmation}
            {popup}
            {type && type === "Wizard" ?
                <div>
                    {AuditPopup}
                    {isLoading ? <Loader /> : null}
                    <div className="pb-15">{AddNewProcedureCodesModalBody()}</div>
                    <ModalFooter isSaved={onProcedureSave ? onDeleteProcedure : onClose} handleSave={handleSaveProcedure} UpdatedDate={mainProcedureModal.UpdatedDate} UpdatedBy={mainProcedureModal.UpdatedBy} ID={ProcedureCodes} IsEditAllowed={IsEditAllowed} />
                </div> :
                <Modal show={isOpenProcedure} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-xxl hk-modal-v1 justify-content-center add_new_procedre">
                    {AuditPopup}
                    <Modal.Body>
                        <ModalHeader HeaderName={SetProcedureName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} isClosed={onProcedureSave ? onDeleteProcedure : onClose} key={633} Name={'Procedures'} IsDeleteAllowed={IsDeleteAllowed} />
                        {isLoading ? <Loader /> : null}
                        {AddNewProcedureCodesModalBody()}
                    </Modal.Body>
                    <ModalFooter isSaved={onProcedureSave ? onDeleteProcedure : onClose} handleSave={handleSaveProcedure} UpdatedDate={mainProcedureModal.UpdatedDate} UpdatedBy={mainProcedureModal.UpdatedBy} ID={ProcedureCodes} IsEditAllowed={IsEditAllowed} />
                </Modal>
            }
        </React.Fragment>
    )
}

export default AddNewProcedureCodes